import {
  type ShiftMigrationRequestBody,
  shiftMigrationsContract,
} from "@clipboard-health/contract-backend-main";
import { post } from "@src/appV2/api/parsedApi";
import { environmentConfig } from "@src/appV2/environment";
import { invalidateFacilityProfileQueries } from "@src/appV2/FacilityProfile/api/useGetFacilityProfile";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useCreateShiftMigration() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: ShiftMigrationRequestBody) => {
      const response = await post({
        url: `${environmentConfig.REACT_APP_API_MAIN_URL}${shiftMigrationsContract.createShiftMigration.path}`,
        data: params,
        bodySchema: shiftMigrationsContract.createShiftMigration.body,
        responseSchema: shiftMigrationsContract.createShiftMigration.responses[200],
      });

      return response.data;
    },
    onSuccess: (_data, variables) => {
      if (!variables.dryRun) {
        invalidateFacilityProfileQueries(queryClient, variables.originFacilityId);
        invalidateFacilityProfileQueries(queryClient, variables.destinationFacilityId);
      }
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.CREATE_SHIFT_MIGRATION_FAILURE,
    },
  });
}
